import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export const LandingHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLoginClick = () => {
    if (user) {
      const isMasterUser = user.email?.endsWith('@letswatch.com.br') || user.email === 'master@admin.com';
      navigate(isMasterUser ? "/paneladmin" : "/dashboard");
    } else {
      navigate("/auth");
    }
  };

  const handleStartFree = () => {
    if (user) {
      navigate("/dashboard");
    } else {
      navigate("/auth?signup=true");
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled || isMenuOpen
        ? 'bg-[#0a2e1f]/95 backdrop-blur-md shadow-2xl py-2'
        : 'bg-[#0a2e1f] py-4 lg:py-5'
        }`}>
        <div className="max-w-[1440px] mx-auto px-6 flex justify-between items-center">
          <div className="flex items-center">
            <a href="/landing" className="block">
              <img
                src="https://locaninja.com/logotipo-watch.png"
                alt="Watch Smart Media Logo"
                className="h-10 lg:h-12 w-auto block object-contain"
                style={{ minWidth: '100px' }}
              />
            </a>
          </div>

          <div className="hidden lg:flex items-center gap-10">
            <a href="#features" className="text-sm font-black uppercase tracking-widest text-white hover:text-primary transition-colors">
              Vantagens
            </a>
            <a href="#how-it-works" className="text-sm font-black uppercase tracking-widest text-white hover:text-primary transition-colors">
              Como funciona
            </a>
            <button
              onClick={handleLoginClick}
              className="bg-white text-gray-900 px-8 py-3 rounded-full font-black text-xs uppercase tracking-widest hover:bg-primary hover:text-white transition-all shadow-lg"
            >
              {user ? "Dashboard" : "Entrar"}
            </button>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-white transition-transform active:scale-90"
            aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
          >
            {isMenuOpen ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-0 z-40 bg-[#0a2e1f] transition-transform duration-500 lg:hidden ${isMenuOpen ? 'translate-y-0' : '-translate-y-full'
        }`}>
        <div className="flex flex-col h-full pt-32 px-6 pb-12 text-white">
          <div className="flex flex-col gap-8">
            <a
              href="#features"
              onClick={() => setIsMenuOpen(false)}
              className="text-4xl font-black tracking-tight border-b border-white/10 pb-4"
            >
              Vantagens
            </a>
            <a
              href="#how-it-works"
              onClick={() => setIsMenuOpen(false)}
              className="text-4xl font-black tracking-tight border-b border-white/10 pb-4"
            >
              Como funciona
            </a>
          </div>
          <div className="mt-auto flex flex-col gap-4">
            <button
              onClick={handleStartFree}
              className="w-full bg-primary text-white py-5 rounded-2xl font-black text-xl hover:bg-primary/90 transition-colors"
            >
              Teste Grátis 7 Dias
            </button>
            <button
              onClick={() => { handleLoginClick(); setIsMenuOpen(false); }}
              className="w-full bg-white text-gray-900 py-5 rounded-2xl font-black text-xl hover:bg-gray-100 transition-colors"
            >
              {user ? "Ir para Dashboard" : "Entrar na Conta"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
